import React from 'react'
import { $consts } from 'src/plugins'

const Layout = React.lazy(() => import('enasops/layout'))
const Login = React.lazy(() => import('enasops/modules/login'))
const Main = React.lazy(() => import('enasops/modules/main'))

const routes = [
  {
    path: $consts['ROUTE/ROOT'],
    redirect: $consts['ROUTE/MAIN'],
    children: [
      {
        path: $consts['ROUTE/LOGIN'],
        component: Login
      },
      {
        path: $consts['ROUTE/MAIN'],
        component: Main
      }
    ],
    component: Layout
  },
]

export default routes